import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.328 16.542a7.501 7.501 0 1 1 1.091-1.03l4.112 4.11a.75.75 0 1 1-1.06 1.061zm1.424-5.944a6.001 6.001 0 1 1-12.002 0 6.001 6.001 0 0 1 12.002 0",
    clipRule: "evenodd"
  }));
}
var IcSearch = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSearch));

export { IcSearch as I };
